import {BasicScenario} from '../../../../allkey/framework/parameters/BasicScenario';

export class MetaProcessScenario extends BasicScenario {
manageEngines: boolean | null;
manageProcess: boolean | null;
}

